"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};


//////////////////
// WEBPACK FOOTER
// D:/midea_porject/php/htdocs/~/babel-runtime/helpers/classCallCheck.js
// module id = 22
// module chunks = 0